import React from "react";
import styles from './BillingPaymentResult.module.scss';
import { COMPANY_EMAIL } from "../../../common/constants/company";


const BillingPaymentResult: React.FC = (option) => (
    // const { payOption } = useParams<{ payOption: string }>();
    // const [isLoading, setIsLoading] = useState<boolean>(false)
    // const dispatch = useAppDispatch();
    // const { payOption } = useAppSelector(state => state.payOption)

    <div className={styles.page}>
        <h1 className={styles.fadeIn}>Payment was successful.</h1>
        <p className={styles.fadeIn}> If you paid without logging into the system, please notify the company about this payment by email.</p>
        <p className={styles.fadeIn}><a href={COMPANY_EMAIL}>{COMPANY_EMAIL}</a></p>
    </div>
);

export default BillingPaymentResult;